import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { __ } from "@/i18n";
import { SectionCard } from "@/components/ui/section-card";
import { Stepper } from "./stepper";
import type { Step1Form } from "@/constants/statement-constants";

interface StatementStep1Props {
  step1: Step1Form;
  onChange: (updated: Step1Form) => void;
  onNext: () => void;
}

export function StatementStep1({ step1, onChange, onNext }: StatementStep1Props) {
  const isValid =
    step1.companyName.trim() !== "" &&
    step1.businessEmail.trim() !== "" &&
    step1.website.trim() !== "";

  return (
    <SectionCard className="cy:border cy:border-gray-200">
      <h3 className="cy:text-[18px] cy:font-semibold cy:text-foreground cy:mb-1">
        {__( 'Generate statement', 'accessibility-widget' )}
      </h3>
      <hr className="cy:border-gray-200 cy:mb-6" />

      <div className="cy:max-w-lg">
        <Stepper step={1} />
      </div>

      <div className="cy:space-y-4 cy:max-w-lg">
        <div className="cy:space-y-1.5">
          <Label htmlFor="company-name" className="cy:text-[16px] cy:font-medium cy:text-foreground">
            {__( 'Company Name', 'accessibility-widget' )}<span className="cy:text-red-500 cy:ml-0.5">*</span>
          </Label>
          <Input
            id="company-name"
            value={step1.companyName}
            onChange={(e) => onChange({ ...step1, companyName: e.target.value })}
            placeholder={__( 'Company Inc.', 'accessibility-widget' )}
            className="cy:h-[48px] cy:border! cy:rounded!"
          />
        </div>
        <div className="cy:space-y-1.5">
          <Label htmlFor="business-email" className="cy:text-[16px] cy:font-medium cy:text-foreground">
            {__( 'Business E-mail', 'accessibility-widget' )}<span className="cy:text-red-500 cy:ml-0.5">*</span>
          </Label>
          <Input
            id="business-email"
            type="email"
            value={step1.businessEmail}
            onChange={(e) => onChange({ ...step1, businessEmail: e.target.value })}
            placeholder={__( 'info@company.com', 'accessibility-widget' )}
            className="cy:h-[48px] cy:border! cy:rounded!"
          />
        </div>
        <div className="cy:space-y-1.5">
          <Label htmlFor="website" className="cy:text-[16px] cy:font-medium cy:text-foreground">
            {__( 'Website', 'accessibility-widget' )}<span className="cy:text-red-500 cy:ml-0.5">*</span>
          </Label>
          <Input
            id="website"
            type="url"
            value={step1.website}
            onChange={(e) => onChange({ ...step1, website: e.target.value })}
            placeholder={__( 'https://company.com', 'accessibility-widget' )}
            className="cy:h-[48px] cy:border! cy:rounded!"
          />
        </div>
      </div>

      <hr className="cy:border-gray-200 cy:mt-6" />
      <div className="cy:mt-6 cy:flex cy:justify-end">
        <Button onClick={onNext} disabled={!isValid} className="cy:rounded">
          <span className="cy:text-[16px]">{__( 'Next', 'accessibility-widget' )}</span>
        </Button>
      </div>
    </SectionCard>
  );
}
